export function PMLogo() {
  return (
    <img
      className="h-14 flex-none"
      src="https://cdn.pm-international.com/assets-shared-frontend/company-logos/pm.svg"
      alt="PM Logo"
    />
  );
}
